import BrandManagement from '@/vuepage/brand/index';
import BrandList from '../vuepage/brand/list';
import BrandAdd from '../vuepage/brand/brand-add';

export default [
  {
    path: '/brand-management',
    component: BrandManagement,
    children: [
      {
        path: 'list',
        component: BrandList,
        meta: [
          {
            name: '品牌管理',
            url: '/brand-management',
          },
          {
            name: '品牌列表',
            url: 'list',
          },
        ],
      },
      {
        path: 'brand-add',
        component: BrandAdd,
        meta: [
          {
            name: '品牌管理',
            url: '/brand-management',
          },
          {
            name: '品牌列表',
            url: 'list',
          },
          {
            name: '新增/编辑品牌',
            url: 'brand-add',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/brand.js